/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeUnlimitedInstallStepsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('TIER_FREE_UNLIMITED_INSTALL_STEPS_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeUnlimitedInstallStepsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeUnlimitedInstallStepsEnabledSettingParser.decode(input).map(res => new TierFreeUnlimitedInstallStepsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeUnlimitedInstallStepsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeUnlimitedInstallStepsEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeUnlimitedInstallStepsEnabledSettingParser.schema();
    }
}
